<template lang="pug">
b-form-group(:class="desktop ? 'mt-3 ml-2' : 'relative'")
  b-form-input.search-input(
    :value="value"
    placeholder="Ingrese su búsqueda..."
    @input="$emit('input', $event)"
    @keydown.enter.prevent="$emit('search')"
    :class="desktop ? '' : 'w-100'"
  )
  div.icons-container
    b-spinner(
      v-if="loading"
      small
      class="mr-2"
    )
    b-icon.action-icon.mr-2(
      icon="search" 
      variant="primary" 
      font-scale="1.2" 
      @click="$emit('search')"
    )
    b-icon.action-icon.mr-2(
      v-if="value"
      icon="x" 
      variant="primary" 
      font-scale="1.5" 
      @click="$emit('clearParamsSearch')"
    )

</template>

<script>

export default {
  name: 'OVSearchInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    desktop: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
    }
  }
}
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
}

.icons-container {
  position: absolute;
  display: flex;
  align-items: center;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 10;
}

.action-icon {
  cursor: pointer;
}

.search-input {
  width: 260px;
  float: right;
  
  padding-right: 60px; 
}

.w-100 {
  width: 100% !important;
}
</style>